import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function Trade() {
  const face = FACE_BY_ID.trade;
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="Fintech"
      titulo="Automação de mercado, com o encanamento embaixo."
      intro="Interface de terminal, dado de mercado chegando em tempo real, motor de regras e o registro que permite auditar depois o que a máquina fez."
      entrego={[
        {
          titulo: "Motor de regras",
          corpo: "Automação dirigida a evento, com teste contra histórico antes de qualquer coisa valer dinheiro.",
        },
        {
          titulo: "Dado de mercado",
          corpo: "Conexão contínua, normalização de candle e cache que respeita o atraso aceitável de cada tela.",
        },
        {
          titulo: "Interface de terminal",
          corpo: "Painel em tempo real e fluxo de alerta, feitos para serem lidos rápido e sem dúvida.",
        },
        {
          titulo: "Registro e segredo",
          corpo: "Log que serve de auditoria, segredo fora do código e repasse de verificação de identidade.",
        },
      ]}
      publicado={[
        {
          titulo: "Cypher Bot",
          marca: "Em construção",
          corpo: "Plataforma de automação com regras, integração de dados de mercado e interface de terminal.",
          link: "https://app.cypher-bot.com",
        },
        {
          titulo: "ATR Trailing Stop com EMA",
          marca: "Nelogica · 2025",
          corpo: "Indicador e estratégia no marketplace do Profit Pro. Compra quando o preço fecha acima do stop e a média cruza para cima, vende na condição espelhada. Sensibilidade ajustável e alerta em tempo real.",
          link: "https://nelogica.com.br/estrategias?id=10748",
        },
      ]}
      nota="Nada aqui é recomendação de investimento. Estratégia publicada é ferramenta, não promessa de retorno, e o risco continua sendo de quem opera."
    />
  );
}
